<template>
  <div>
    <sparkline 
      title="Cost Per Record"
      color="#13B8A6"
      :loading="loading"
      :series="data"
      :total="total"
      :start="start" 
      :end="end"
      :format="val => { return `R${val.toFixed(2)} ZAR` }" />
  </div>
</template>

<script>
import { sub } from 'date-fns'
import Sparkline from '@/components/Sparkline'

export default {
  name: 'CostPerRecord',

  components: {
    Sparkline
  },

  created () {
    this.fetchData()
  },

  computed: {
    data () {
      return [{
        name: 'Cost Per Kilometre',
        data: this.dataset.map(item => { 
          return {
            x: item.interval.s,
            y: (Math.random() * 100).toFixed(2) // item.cpk 
          }
        })
      }]
    },

    start () {
      return this.dataset.length ? this.dataset[0].interval.s : ''
    },

    end () {
      return this.dataset.length ? this.dataset[this.dataset.length - 1].interval.e : ''
    }
  },

  data () {
    return {
      dataset: [],
      total: {},
      loading: true
    }
  },

  methods: {
    async fetchData () {
      try {
        const { data } = await this.$api.get(`account/${this.$route.params.account}/overview/cpk`, {
          params: {
            from: sub(new Date(), { months: 12 }),
            to: new Date()
          }
        })
        this.dataset = data.dataset
        this.total.primary = data.total
        this.total.primary = 899.94
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>